import { FUNNEL_STEPS } from '../stepConfiguration';

import { SPECIALTY_FLOW } from './config';

// TODO this should be a shared function between all branching funnels that also checks config ID,
// but since we only have one and will be refactoring soon, we can leave it here for now
const isBranchActive = ({ storage, newBranch, branchName }) => {
  const activeBranch = newBranch || storage.getConfigBranch();
  return activeBranch === branchName;
};

const BRANCH_ORDERS = {
  [SPECIALTY_FLOW.BRANCHES.ROOT]: [
    FUNNEL_STEPS.Welcome,
    FUNNEL_STEPS.Location,
    FUNNEL_STEPS.Reason,
  ],
  [SPECIALTY_FLOW.BRANCHES.URGENT]: [
    FUNNEL_STEPS.ReasonDetails,
    FUNNEL_STEPS.LastVisited,
    FUNNEL_STEPS.Anxiety,
    FUNNEL_STEPS.Insurance,
    FUNNEL_STEPS.Contact,
  ],
  [SPECIALTY_FLOW.BRANCHES.NEW_DENTIST]: [
    FUNNEL_STEPS.Attitude,
    FUNNEL_STEPS.LastVisited,
    FUNNEL_STEPS.Anxiety,
    FUNNEL_STEPS.Goals,
    FUNNEL_STEPS.ReasonDetails,
    FUNNEL_STEPS.Availability,
    FUNNEL_STEPS.HowSoon,
    FUNNEL_STEPS.Criteria,
    FUNNEL_STEPS.Insurance,
    FUNNEL_STEPS.Contact,
  ],
  [SPECIALTY_FLOW.BRANCHES.SPECIALIST]: [
    FUNNEL_STEPS.SpecialistType,
    FUNNEL_STEPS.ReasonDetails,
    FUNNEL_STEPS.SpecialistReferral,
    FUNNEL_STEPS.LastVisited,
    FUNNEL_STEPS.Anxiety,
    FUNNEL_STEPS.Insurance,
    FUNNEL_STEPS.Contact,
  ],
};

const generateOrder = (branchName) => {
  const rootOrder = BRANCH_ORDERS[SPECIALTY_FLOW.BRANCHES.ROOT];
  const branchOrder = BRANCH_ORDERS[branchName] || [];

  // We will never use the steps after `Reason`, but we need to include them
  // to make the percentage bar accurate
  // When we move to the new progress bar we can remove this
  if (branchName === SPECIALTY_FLOW.BRANCHES.ROOT) {
    return [
      ...rootOrder,
      ...BRANCH_ORDERS[SPECIALTY_FLOW.BRANCHES.NEW_DENTIST],
    ];
  }

  // Include root order to allow backwards navigation
  const order = Array.from(new Set([...rootOrder, ...branchOrder]));
  return order;
};

const generateBranchConfig = (branchName) => ({
  id: SPECIALTY_FLOW.CONFIG_ID,
  branchName,
  markets: SPECIALTY_FLOW.MARKETS,
  active: (params) =>
    SpecialtyFlow.isBranchActive({
      ...params,
      branchName,
    }),
  order: generateOrder(branchName),
});

export const SpecialtyFlow = {
  isBranchActive,
  generateBranchConfig,
  generateOrder,
};
